import { render } from "./TextLabel.vue?vue&type=template&id=80e76024&scoped=true&ts=true"
import script from "./TextLabel.vue?vue&type=script&lang=ts"
export * from "./TextLabel.vue?vue&type=script&lang=ts"

import "./TextLabel.vue?vue&type=style&index=0&id=80e76024&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80e76024"]])

export default __exports__